<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only" >
    <fs1-span><b>{{label || ''}}</b></fs1-span>
    <slot></slot>
    <v-combobox
      v-model="model"
      :search-input.sync="search"
      :class="[value ? '': (required && 'textEmpty')]"
      :prepend-icon="p_icon"
      :append-icon="a_icon"
      :item-text="item_key"
      clearable
      @change="change_m"
      @click:clear="(e)=>change_m(null,e)"
      :items="string_items"
    />
  </pre_input>
</template>

<script>
import pre_input_js from '@/components/mixins/pre_input';
import Debounce from '@/components/Debounce';
import inputs from '../mixins/inputs/inputs.js';
import filter from '@/components/mixins/filter';
export default {
  props:{
    required:{default:true},
    f_key:{},
    value_key:{},
    item_key:{},
    value:{default:null},
  },
  mixins: [ inputs, Debounce, pre_input_js, filter  ],
  data(){
    return {
      model: null,
      items: [],
      search:null,
      rq_name:'in-user',
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
    string_items(){
      const l = this.items.map(m=>{ return typeof m == 'object'? {...m}:m});
      return this.items_on_search && !this.search?[]:l.map(m => (m[this.k_f] = m[this.k_f]+'') && m)
    },
    value_model_dif(){return this.value !== (this.model||{})[this.value_key]}
  },
  watch: {
    'search'(v,o){
      if (v === null && o === null) return;// valor xdef es null asi evita la primera carga
      if (v !== null) this.debounceM('search', ()=>this.searchM(v,o));
    },
    'model'(v,o) {
      if(this.value_model_dif) this.upd();
      
      },
    'value':{
      immediate: true,
      handler(v,o) {
this.dev_log('value',{v,o},this.value_model_dif,(this.model||{})[this.value_key]);
        if(this.value_model_dif) {
          this.dev_log('value->',{v,o});
          this.set_model() 
          
          }
      },

    }
  },
  created() { this.d_time = 1000 },
  methods: {
    change_m(val,ev){
      if (typeof val === 'object' && val != null) { // es obj cuando se selecciono un item, sino es string (seccion del nombre buscado)
        if (val[this.value_key] != this.value) this.upd();
      }
      else if (typeof val === 'string' || val === null && this.value != null)  this.$emit('update:value', null); 
    },
    set_model() {
      this.search = null;
      const ex_f = {};
      ex_f[this.value_key] = this.value;
      if (this.value === null) this.items = [];
      else this.getRows(ex_f)
        .then(r => {
          const f = this.items.find(f => f[this.value_key] === this.value) || {};
          if (this.items.length === 1) this.model = this.items[0];
          this.search = f[this.item_key];
          return r
        })
    },
    searchM(v,o){
      const val = v;
      if (this.filter[this.k_f] === val) return;//si se esta usando como valor el mismo rqstatus, se gatillara 2 veces al cargar || cuando se intente buscar los mismo
      const filter = {};
      filter[this.k_f] = this.search;
			this.getRows(filter)
        .then(r =>{
          if (this.items.length === 1) this.model = this.items[0];
          return r
        });
    },
    upd(){
      if (this.model) this.$emit('update:value', this.model[this.value_key]);
    },
    getRows(ex_f={}){
      this.reset_rq_status();
      return this.requests.gets[`${this.rq_name}/a/all`](ex_f)
        .then(r => this.then_get_rows(r));
    },
    then_get_rows(r) {
      this.items = (((r || {}).results || r) || []);
      return r;
    },
    reset_rq_status(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    }
  },
};
</script>
